import { Theme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Table(theme: Theme) {
  return {
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "rgba(204,231,255,0.2)",
            "&:hover": {
              backgroundColor: "rgba(204,231,255,0.2)",
            },
            "& td:first-of-type": {
              borderTopLeftRadius: theme.shape.borderRadius,
              borderTopRightRadius: 0,
              borderBottomLeftRadius: 0,
              borderTop: "solid 1px #eee",
              borderLeft: "solid 1px #eee",
            },
            "& td:last-of-type": {
              borderTopRightRadius: theme.shape.borderRadius,
              borderTopLeftRadius: 0,
              borderBottomRightRadius: 0,
              borderTop: "solid 1px #eee",
              borderRight: "solid 1px #eee",
            },
            "& td": {
              borderTopRightRadius: theme.shape.borderRadius,
              borderTop: "solid 1px #eee",
            },
          },
          "& td:first-of-type": {
            borderTopLeftRadius: theme.shape.borderRadius,
            borderBottomLeftRadius: theme.shape.borderRadius,
          },
          "& td:last-of-type": {
            borderTopLeftRadius: theme.shape.borderRadius,
            borderBottomLeftRadius: theme.shape.borderRadius,
          },
          "&:hover": {
            backgroundColor: "#CCE7FF32",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: "none",
        },
        head: {
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.neutral,
          "&:first-of-type": {
            paddingLeft: theme.spacing(2),
            borderTopLeftRadius: theme.shape.borderRadius,
            borderBottomLeftRadius: theme.shape.borderRadius,
            boxShadow: `none`,
          },
          "&:last-of-type": {
            paddingRight: theme.spacing(2),
            borderTopRightRadius: theme.shape.borderRadius,
            borderBottomRightRadius: theme.shape.borderRadius,
            boxShadow: `none`,
          },
        },
        stickyHeader: {
          backgroundColor: theme.palette.background.paper,
          backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.neutral} 0%, ${theme.palette.background.neutral} 100%)`,
        },
        body: {
          padding: theme.spacing(1.5),
          "@media (max-width:900px)": {
            padding: theme.spacing(1),
          },
          "&:first-of-type": {
            paddingLeft: theme.spacing(2),
          },
          "&:last-of-type": {
            paddingRight: theme.spacing(2),
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          borderTop: `solid 1px ${theme.palette.divider}`,
        },
        toolbar: {
          height: 64,
        },
        select: {
          "&:focus": {
            borderRadius: theme.shape.borderRadius,
          },
        },
        selectIcon: {
          width: 20,
          height: 20,
          marginTop: -4,
        },
      },
    },
  };
}
